import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchIncomeRecord = createAsyncThunk(
  "incomeRecord/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      let url = "/reports/get-income-record";
      if (filters.recordType === "with details")
        url = "/accounts/get-income-with-details";
      if (filters.filterType === "By Income")
        url = "/reports/get-income-record-details";

      const payload = {
        selectedFilterType: filters.filterType,
        incId: filters.incId,
        userId: filters.userId,
        fromDate: filters.fromDate,
        toDate: filters.toDate,
      };

      const res = await postData(url, payload);
      return {
        list:
          filters.filterType !== "By Income" &&
            filters.recordType === "without details"
            ? res.data
            : [],
        details: filters.filterType === "By Income" ? res.data : [],
        listWithDetails: filters.recordType === "with details" ? res.data : [],
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// export const fetchIncomeAccountsBySearch = createAsyncThunk(
//   "incomeRecord/fetchAccountsBySearch",
//   async (search, { rejectWithValue }) => {
//     try {
//       const res = await getAccountBySeachApi({
//         query: search.trim(),
//         type: "indirect_income",
//       });
//       return (res.data || []).map((c) => ({
//         sale_id: c.acc_id,
//         display_text: c.acc_name,
//       }));
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

export const fetchIncomeAccountsBySearch = createAsyncThunk(
  "incomeRecord/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const queries = ["direct_income", "indirect_income"];

      const results = await Promise.all(
        queries.map((type) =>
          getAccountBySeachApi({
            query: search.trim(),
            type,
          })
        )
      );

      // Merge both responses into one array
      const merged = results.flatMap((res) =>
        (res.data || []).map((c) => ({
          sale_id: c.acc_id,
          display_text: c.acc_name,
        }))
      );

      return merged;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

